export const PR_CONTENT = {
  hero: {
    kicker: 'Para quem vende produtos, serviços ou obras sob orçamento',
    title: 'Orçamento feito no Word não fecha venda. Proposta profissional, sim.',
    subtitle:
      'Gere propostas comerciais com visual profissional em PDF, acompanhe o status de cada uma e transforme a proposta aprovada em venda ou contrato com um clique — sem sair do sistema.',
    cta: 'Quero profissionalizar meus orçamentos',
    ctaMessage: 'Quero conhecer o sistema de orçamentos e propostas do 77Gestão',
    urgency: 'Cada proposta sem acompanhamento é uma venda que pode estar esfriando na caixa de entrada do cliente.',
  },

  statsStrip: [
    { number: '1 clique', label: 'para gerar a proposta em PDF', icon: 'fa-solid fa-file-pdf' },
    { number: '100%', label: 'de rastreio do status da proposta', icon: 'fa-solid fa-list-check' },
    { number: '0', label: 'retrabalho para converter em venda', icon: 'fa-solid fa-arrow-right-arrow-left' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações? Então você sabe que algo precisa mudar.',
    intro:
      'Empresas que dependem de orçamento antes da venda perdem negócio todos os dias por causa de proposta feita sem padrão e sem acompanhamento. Não é falta de esforço — é falta da ferramenta certa.',
    items: [
      { icon: 'fa-solid fa-file-word', text: 'Orçamento montado no Word, no papel ou direto no corpo do WhatsApp, sem padrão nenhum.' },
      { icon: 'fa-solid fa-magnifying-glass', text: 'Ninguém sabe quantas propostas foram enviadas nem quantas viraram venda de fato.' },
      { icon: 'fa-solid fa-ghost', text: 'Proposta enviada e esquecida — o cliente some e ninguém retoma o contato a tempo.' },
      { icon: 'fa-solid fa-people-arrows', text: 'Cada vendedor monta a proposta de um jeito diferente, sem a cara da empresa.' },
      { icon: 'fa-regular fa-clock', text: 'Depois que o cliente aprova, é preciso recomeçar do zero para gerar a venda ou o contrato.' },
    ],
  },

  midCta: {
    text: 'E se cada proposta aprovada virasse venda ou contrato automaticamente, sem digitar nada de novo?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema de orçamentos e propostas do 77Gestão',
  },

  solution: {
    title: 'Propostas com cara profissional e acompanhamento até o fechamento.',
    intro:
      'O módulo de propostas do 77Gestão foi pensado para quem precisa formalizar o orçamento antes de vender — com visual profissional, controle de status e conversão direta em venda.',
    cards: [
      {
        icon: 'fa-solid fa-file-pdf',
        title: 'PDF profissional e customizável',
        text: 'Gere propostas com template próprio da sua empresa, logo, cores e condições — pronto para enviar ao cliente em segundos.',
      },
      {
        icon: 'fa-solid fa-list-check',
        title: 'Status de cada proposta',
        text: 'Acompanhe o que foi enviado, aprovado ou recusado. Chega de perder o controle de quantas propostas estão em aberto.',
      },
      {
        icon: 'fa-solid fa-comments-dollar',
        title: 'Origem da negociação identificada',
        text: 'Marque o canal de cada proposta (loja física, WhatsApp, indicação) e saiba de onde vêm suas negociações sem depender da memória do vendedor.',
      },
      {
        icon: 'fa-solid fa-arrow-right-arrow-left',
        title: 'Proposta aprovada vira venda ou contrato',
        text: 'Com um clique, a proposta aprovada gera a venda com emissão de nota ou o contrato — sem digitar tudo de novo.',
      },
      {
        icon: 'fa-solid fa-hand-holding-dollar',
        title: 'Comissão já vinculada',
        text: 'Quando a proposta vira venda, a comissão do vendedor responsável já é calculada automaticamente.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a proposta deixa de ser feita no Word',
    intro:
      'Uma empresa de serviços enviava orçamento por e-mail em um documento simples, sem padrão. Ninguém media quantas propostas viravam contrato nem sabia quais estavam paradas há semanas.',
    stats: [
      { number: '100%', label: 'das propostas com status visível' },
      { number: '2x', label: 'mais propostas convertidas em venda' },
      { number: '0', label: 'retrabalho ao gerar venda ou contrato' },
    ],
    paragraphs: [
      'Depois da implantação, todas as propostas passaram a ser geradas em um template único, com visual profissional e acompanhamento de status dentro do sistema.',
      'A equipe comercial passou a saber exatamente quais propostas estavam paradas e retomar o contato antes de perder a venda — e as propostas aprovadas passaram a virar venda com um clique, sem recomeçar do zero.',
    ],
    highlight: 'Resultado: mais propostas fechadas, zero retrabalho e uma imagem mais profissional para o cliente.',
    cta: 'Quero esse nível de controle',
    ctaMessage: 'Vi o resultado e quero entender como profissionalizar minhas propostas no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a gestão de propostas',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Todas as propostas enviadas, aprovadas ou recusadas disponíveis em um só lugar — não espalhadas em e-mails.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Template padronizado e status rastreado garantem que nenhuma proposta se perca no meio do caminho.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Saiba quantas propostas estão em aberto e quantas tendem a virar venda, sem depender do feeling do vendedor.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para orçamentos e propostas',
    items: [
      { icon: 'fa-solid fa-link', text: 'Proposta integrada a vendas, contratos e comissão — um clique conecta tudo.' },
      { icon: 'fa-solid fa-palette', text: 'Template com a identidade visual da sua empresa, sem depender de designer.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: sua equipe começa a usar o template já configurado.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Consigo personalizar a proposta com a cara da minha empresa?',
        answer:
          'Sim. O template de proposta é customizável com logo, cores e condições comerciais próprias da sua empresa, gerando um PDF profissional.',
      },
      {
        question: 'O que acontece depois que o cliente aprova a proposta?',
        answer:
          'A proposta aprovada pode ser convertida diretamente em venda, com emissão de nota, ou em contrato — sem precisar recadastrar nada.',
      },
      {
        question: 'Dá para saber quantas propostas viraram venda?',
        answer:
          'Sim. O sistema acompanha o status de cada proposta (enviada, aprovada, recusada), dando visibilidade real da taxa de conversão.',
      },
      {
        question: 'Funciona para orçamento de obra ou serviço, não só produto?',
        answer:
          'Sim. O módulo de propostas atende comércio, serviços e obras — qualquer negócio que precise formalizar um orçamento antes de fechar.',
      },
      {
        question: 'Minha equipe já usa modelos próprios em Word. Vale a pena migrar?',
        answer:
          'Vale, principalmente pelo controle: além do visual profissional, você passa a ter status, histórico e conversão automática em venda ou contrato — algo que o Word não oferece.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de perder venda por causa de um orçamento mal feito.',
    subtitle:
      'Agende uma demonstração e veja, na prática, como gerar propostas profissionais, acompanhar o status de cada uma e converter aprovação em venda sem retrabalho.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema de orçamentos e propostas do 77Gestão',
  },

  seo: {
    title: 'Sistema de Orçamentos e Propostas Comerciais | 77Gestão',
    description:
      'Software para propostas comerciais com template profissional em PDF, status de acompanhamento e conversão automática em venda ou contrato. Agende uma demo.',
  },
};
